var map = {
	"./af/Category.json": "./src/modules/shop/src/locales/af/Category.json",
	"./af/CostCentre.json": "./src/modules/shop/src/locales/af/CostCentre.json",
	"./af/CustomerLocation.json": "./src/modules/shop/src/locales/af/CustomerLocation.json",
	"./af/Delivery.json": "./src/modules/shop/src/locales/af/Delivery.json",
	"./af/PickingList.json": "./src/modules/shop/src/locales/af/PickingList.json",
	"./af/PickingListItem.json": "./src/modules/shop/src/locales/af/PickingListItem.json",
	"./af/PreferredDeliveryAddress.json": "./src/modules/shop/src/locales/af/PreferredDeliveryAddress.json",
	"./af/Shop.json": "./src/modules/shop/src/locales/af/Shop.json",
	"./af/StockItem.json": "./src/modules/shop/src/locales/af/StockItem.json",
	"./af/Supplier.json": "./src/modules/shop/src/locales/af/Supplier.json",
	"./af/common.json": "./src/modules/shop/src/locales/af/common.json",
	"./en/Category.json": "./src/modules/shop/src/locales/en/Category.json",
	"./en/CostCentre.json": "./src/modules/shop/src/locales/en/CostCentre.json",
	"./en/CustomerLocation.json": "./src/modules/shop/src/locales/en/CustomerLocation.json",
	"./en/Delivery.json": "./src/modules/shop/src/locales/en/Delivery.json",
	"./en/Orders.json": "./src/modules/shop/src/locales/en/Orders.json",
	"./en/PickingList.json": "./src/modules/shop/src/locales/en/PickingList.json",
	"./en/PickingListItem.json": "./src/modules/shop/src/locales/en/PickingListItem.json",
	"./en/PreferredDeliveryAddress.json": "./src/modules/shop/src/locales/en/PreferredDeliveryAddress.json",
	"./en/RestaurantAdmins.json": "./src/modules/shop/src/locales/en/RestaurantAdmins.json",
	"./en/Shop.json": "./src/modules/shop/src/locales/en/Shop.json",
	"./en/StockItem.json": "./src/modules/shop/src/locales/en/StockItem.json",
	"./en/Supplier.json": "./src/modules/shop/src/locales/en/Supplier.json",
	"./en/common.json": "./src/modules/shop/src/locales/en/common.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/shop/src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";